export default __webpack_public_path__ + "static/media/logo_macro.466cc1f5.jpg";